import { EventRouter } from "../../../common/events"

export class Events {
    static dropDownToggle = new EventRouter<boolean>("dropDownToggle")
    static updatesAreRead = new EventRouter<void>("updatesAreRead")
    static updatesAreUnread = new EventRouter<void>("updatesAreUnread")
    static tabItemsLoaded = new EventRouter<void>("tabItemsLoaded")
}
